import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { latLng, tileLayer } from 'leaflet';
import { ChartType, Stat, Chat, Transaction } from './dashboard.model';
import { revenueChart, salesAnalytics, sparklineEarning, sparklineMonthly, chatData, transactions, spark3Chart, spark2Chart, spark1Chart } from './data';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { reference } from '@popperjs/core';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
interface ChartConfig {
  series: any[];
  chart: any;
  stroke: any;
  plotOptions: any;
  dataLabels: any;
  legend: any;
  colors: string[];
  labels: string[];
  xaxis?: any;
  yaxis?: any;
  tooltip?: any;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

/**
 * Dashboard Component
 */


export class DashboardComponent implements OnInit {

  term: any;
  chatData: Chat[];
  transactions: Transaction[];
  statData: Stat[];
  showUser: any;
  userInfo: any;
  annee: any;
  items: any = [] = [];
  projetData: any[] = [];
  statsEnretard: any;
  @ViewChild('detailModal') modalContent: TemplateRef<any>;
  @ViewChild('detailActivite') modalContent1: TemplateRef<any>;
  paginatedItems = [];
  first: number = 0; // La page actuelle (commence à 0)
  rows: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;

  paginatedItemsActivite = [];
  firstActivite: number = 0; // La page actuelle (commence à 0)
  rowsActivite: number = 10; // Nombre d'éléments par page
  totalRecordsActivite: number = 0; // Nombre total d'éléments

  constructor(
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private FecthDataService: FecthDataService
  ) {
    this.formData = this.formBuilder.group({
      message: ['', [Validators.required]],
    });
    this.userInfo = this.localstorage.getInfoUserToService();
    this.showUser = this.userInfo?.data?.groupe;
    this.annee = Number(this.localstorage.getExerciceToUserToSuivieEvaluation());
    console.log("annee =", this.annee);
    const today = new Date();
    const currentYear = today.getFullYear();
    console.log("currentYear =", currentYear, typeof currentYear);

    const formatDate = (date: Date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };

    this.date_debut = `${this.annee}-01-01`;

    if (this.annee === currentYear) {
      this.date_fin = formatDate(today);
    } else {
      this.date_fin = `${this.annee}-12-31`;
    }

    this.FecthDataService.actionCreated$.subscribe(() => {
      this.getHistogrammeData();

    })
    this.getStatsEnRetard();

  }

  // bread crumb items
  breadCrumbItems: Array<{}>;
  revenueChart: ChartType;
  revenueChartotal: ChartType;
  revenueChartauxDecaissement: ChartType;
  revenuhistogrammeData: ChartType
  salesAnalytics: ChartType;
  sparklineEarning: ChartType;
  sparklineMonthly: ChartType;
  spark1: any;
  spark2: any;
  spark3: any;

  date_debut: any
  date_fin: any

  // Form submit
  chatSubmit: boolean;
  formData: UntypedFormGroup;



  ngOnInit(): void {

  }

  //recuperation des statistiques
  getHistogrammeData() {
    //check
    //const currentYear = new Date().getFullYear();
    // let dateDebut = `${this.annee}-01-01`;
    // let dateFin = new Date().toISOString().split('T')[0];
    // this.date_debut = dateDebut;
    // this.date_fin = dateFin;
    //this.isLoading = true;

    const requestData = {
      date_debut: this.date_debut,
      date_fin: this.date_fin,
      user_reference: this.userInfo.data.reference,
      type_operation: 'data'
    };
    this.ngxService.start();
    this.paramservice.getStatistiqueEvaluationPta(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.projetData = response.data.datas;

        console.log("this.projetData", this.projetData);


        this.transformToHistogramme(this.projetData);

        //this.totalRecords = this.projetData.length;
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
        //this.isLoading = false;
      }
    );
  }//end getStatistique


  //stats
  getStatsEnRetard() {
    this.paramservice.getStatsEnRetard().subscribe(
      (response: any) => {
        this.statsEnretard = response.data;
        // //console.log("la reponse du webservcie ",this.statsEnretard);
      },
      (error: any) => {
        // //console.log("une erreur est survenu",error);
      }
    )
  }//end getStatsEnRetard

  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.items.slice(start, end);
  }



  messageSave() {
    const message = this.formData.get('message').value;
    const currentDate = new Date();
    if (this.formData.valid && message) {
      // Message Push in Chat
      this.chatData.push({
        align: 'right',
        name: 'Ricky Clark',
        message,
        time: currentDate.getHours() + ':' + currentDate.getMinutes()
      });
      // Set Form Data Reset
      this.formData = this.formBuilder.group({
        message: null
      });
    }
    this.chatSubmit = true;
  }

  transformToHistogramme(data: any[]) {
    const SEUIL_MIN = 0.0001;

    const configGraphiqueBase = {
      series: [],
      chart: {
        height: 400,
        type: 'bar',
        toolbar: { show: false }
      },
      stroke: {
        width: 2,
        curve: 'smooth'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%',
          borderRadius: 4,
          distributed: false
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF']
        },
        formatter: (val: number) => val.toFixed(2)
      },
      legend: {
        show: true,
        position: 'top'
      },
      colors: ['#3529DD', '#EF5350', '#FF7043'],
      labels: [],
      xaxis: {
        title: { text: 'Programmes' },
        labels: { rotate: -45 }
      },
      yaxis: {
        title: { text: 'Valeur' }
      },
      tooltip: {
        shared: true,
        intersect: false
      }
    };

    // Extraction des labels une seule fois
    const labelsProgrammes = data.map(item => item.programme?.sigle ?? 'Programme sans sigle');

    // Initialisation des graphiques
    this.revenueChart = JSON.parse(JSON.stringify(configGraphiqueBase));
    this.revenueChartotal = JSON.parse(JSON.stringify(configGraphiqueBase));
    this.revenueChartauxDecaissement = JSON.parse(JSON.stringify(configGraphiqueBase));

    this.revenueChart.labels = labelsProgrammes;
    this.revenueChartotal.labels = labelsProgrammes;
    this.revenueChartauxDecaissement.labels = labelsProgrammes;

    // Données du graphique TEP
    const tabTepPrevu = data.map(item => item?.tep_prevu ?? 0);
    const tabTepRealise = data.map(item => item?.tep_realise ?? 0);

    this.revenueChart.series.push(
      { name: 'TEP Prévu', type: 'column', data: tabTepPrevu },
      { name: 'TEP Réalisé', type: 'column', data: tabTepRealise }
    );

    // Graphique d'exécution financière
    this.revenueChartotal.series.push(
      { name: 'Taux engagé ',type: 'column', data: data.map(item => (item?.taux_engage ?? 0) ) },
      { name: 'Taux ordonnancé ', type: 'column', data: data.map(item => (item?.taux_ordonnance ?? 0)) }
    );

    // Taux de décaissement
    const tauxDecaissement = data.map(item => {
      const valeur = parseFloat(item?.taux_decaisse) || 0;

      const valeurArrondie = Math.round(valeur * 100) / 100;

      return Math.abs(valeurArrondie) < SEUIL_MIN ? 0 : valeurArrondie;
    });

    this.revenueChartauxDecaissement.series.push({
      name: 'Taux de décaissement (%)',
      type: 'column',
      data: tauxDecaissement
    });

    // Personnalisation de l'axe Y pour le taux de décaissement
    // this.revenueChartauxDecaissement.yaxis = {
    //   title: { text: 'Taux (%)' },
    //   min: 0,
    //   max: 100,
    //   labels: {
    //     formatter: (val: number) => `${val}%`
    //   }
    // };
  }


  headerClass: string = '';
  openModalUpdateCible(item: any) {
    console.log("item", item);



    // Vérifier si 'item' est un tableau ou s'il est défini, sinon initialiser avec un tableau vide
    this.items = item.pta_taches;

    // Mettre à jour le nombre total de tâches
    this.totalRecords = this.items.length;

    // Définir la couleur d'entête dans le composant
    // this.headerClass = color;

    // Mettre à jour les projets paginés seulement si 'items' contient des éléments
    if (this.items.length > 0) {
      this.updatePaginatedProjets();
    }

    // Ouvre le modal
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }


  activiteItems: any = {};
  openModalActvite(item: any, color: string) {
    console.log("item", item);
    this.headerClass = color;

    this.activiteItems = item;
    this.paginatedItemsActivite = this.activiteItems;
    this.totalRecordsActivite = this.paginatedItemsActivite.length;
    this.updatePaginatedActivite();
    // Ouvre le modal
    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }

  onPageChangeActivite(event: any) {
    this.firstActivite = event.first; // Mise à jour de la page actuelle
    this.rowsActivite = event.rows; // Mise à jour de la page actuelle
    this.updatePaginatedActivite();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedActivite() {
    const start = this.firstActivite;
    const end = start + this.rowsActivite;
    this.paginatedItemsActivite = this.activiteItems.slice(start, end);
  }
}
